/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const green: QtmColor = {
  50: '#edf8e9',
  100: '#d3edc8',
  200: '#b7e1a5',
  300: '#99d481' /* light */,
  400: '#82cb65',
  500: '#6cc24a',
  600: '#5eb242',
  700: '#4a9e38' /* primary */,
  800: '#368a2e',
  900: '#07671c' /* dark */,
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.black,
    800: common.black,
    900: common.white,
  },
};

export default green;
